module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable38.ebf10bfc.jpg";